import { NgModule } from '@angular/core';
import { GravatarModule } from 'ngx-gravatar';
import { AuthModule } from '@bn/auth';
import { DashboardSharedModule } from '@bn/dashboard-shared';
import { MainMenuComponent, MobileMenuComponent, SearchComponent as LayoutSearchComponent, SubMenuComponent, UserProfileComponent } from '@bn/layout';
import { MixpanelEventsDirective } from '@bn/shared/utils/directives';
import {
  AddMenuComponent,
  BillingOverviewComponent,
  DashboardLayoutComponent,
  NotificationsComponent,
  SearchComponent,
  SidebarComponent,
  SupportComponent,
  SurveyWidgetComponent,
  UpdateNotificationComponent,
} from './components';

@NgModule({
  imports: [
    AuthModule,
    BillingOverviewComponent,
    DashboardSharedModule,
    GravatarModule,
    LayoutSearchComponent,
    MainMenuComponent,
    MobileMenuComponent,
    MixpanelEventsDirective,
    SubMenuComponent,
    UserProfileComponent,
    UpdateNotificationComponent,
    SurveyWidgetComponent,
    AddMenuComponent,
    DashboardLayoutComponent,
    NotificationsComponent,
    SearchComponent,
    SidebarComponent,
    SupportComponent,
    AddMenuComponent,
  ],
  providers: [MixpanelEventsDirective],
  exports: [
    AuthModule,
    AddMenuComponent,
    BillingOverviewComponent,
    DashboardLayoutComponent,
    MainMenuComponent,
    MobileMenuComponent,
    NotificationsComponent,
    SearchComponent,
    SubMenuComponent,
    SidebarComponent,
    SupportComponent,
    UserProfileComponent,
  ],
})
export class LayoutModule {}
